import React from 'react';
import AltIso from 'alt/utils/AltIso';
import {Link} from 'react-router';
import imgResolver from '../utils/img-resolver';

import SeoActions from '../actions/SeoActions';
import CompanyStore from '../stores/CompanyStore';

import connectToStores from 'alt/utils/connectToStores';

@AltIso.define((props) => {
    return SeoActions.pushTitle('Welcome');
})
@connectToStores
class DashboardWelcome extends React.Component {
    constructor(props) {
        super(props);

        CompanyStore.getCompany()
    }

    static getPropsFromStores() {
        return {
            companyStore: CompanyStore.getState()
        };
    }

    static getStores() {
        return [CompanyStore];
    }

    validateCompanyProfile(company) {
        const checks = [
            company.billing_address !== '' && company.billing_address !== null,
            company.billing_email !== '' && company.billing_email !== null,
            company.vat_number !== '' && company.vat_number !== null,
            company.city !== '' && company.city !== null,
            company.email !== '' && company.email !== null,
            company.phone !== '' && company.phone !== null,
            company.street !== '' && company.street !== null,
            company.website !== '' && company.website !== null,
        ];
        return checks.every(item => item == true);
    }

    render() {
        const company = this.props.companyStore.company;
        const profileCompleted = this.validateCompanyProfile(company);
        return (
            <div className="view-dashboard-welcome maxwidth-wrapper">
                <div className="view-content">
                    <div className="welcome-img">
                        <img src={require('../styles/images/welcome-fg.png')} alt="Gigpanel" />
                    </div>
                    {this.props.isPro() ? (
                        <div>
                            <h1 className="page-title">Welcome to Gigpanel! Let’s start by completing your profile!</h1>
                            <Link to="completeprofile" className="btn btn-green btn-create-now">Continue</Link>
                        </div>
                    ):(
                        profileCompleted ? (
                            <div>
                                <h1 className="page-title">Welcome to Gigpanel! Let’s start with your first shift!</h1>
                                <Link to="createshift" className="btn btn-green btn-create-now">Create now</Link>
                            </div>
                        ):(
                            <div>
                                <h1 className="page-title">Welcome to Gigpanel! Let’s start by completing your company profile!</h1>
                                <Link to="settingstab" params={{selectedTab: 1}} className="btn btn-green btn-create-now">Complete now</Link>
                            </div>
                        )
                    )}
                </div>
            </div>
        );
    }
}
export default DashboardWelcome;



/** WEBPACK FOOTER **
 ** ./app/src/views/DashboardWelcome.js
 **/